import * as React from 'react'
import { SalesFunnelProvider } from './Provider'
import { type IFilterMode, SingleSelectFilter } from '@user/components/Filters'

export function SalesFunnelFilter(props: IFilterMode) {
  return (
    <SingleSelectFilter
      {...props}
      name="salesFunnelId"
      label="Sales Funnel"
      component={SalesFunnelProvider}
    />
  )
}
